import React from 'react';
import { Box, Container, Paper, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import TermsSection from '../components/TermsSection';
import PublicSiteLayout from '../layouts/PublicSiteLayout';
import SeoHead from '../components/SeoHead';

export default function TermsPage() {
  return (
    <PublicSiteLayout>
      <SeoHead
        title="KNLS LMS Terms & Conditions | KNLS Computers"
        description="Terms, conditions and disclaimer for KNLS LMS and student portal. For Locsy Citizen / Mitra see Locsy Terms."
        canonicalUrl="https://services.knls.in/terms-and-conditions"
      />
      <Box sx={{ py: { xs: 2, sm: 4 } }}>
        <Container maxWidth="md">
          <Paper elevation={0} sx={{ p: { xs: 2, sm: 4 }, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
            <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 800 }}>
              KNLS LMS Terms, conditions & disclaimer
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              KNLS LMS / student portal only — not Locsy Citizen or Mitra marketplace terms. Please read carefully
              before payment or registration.
            </Typography>

            <TermsSection />

            <Box sx={{ mt: 4, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <Button component={RouterLink} to="/privacy-policy" variant="outlined">
                Privacy Policy
              </Button>
              <Button component={RouterLink} to="/locsy-terms-and-conditions" variant="outlined">
                Locsy Terms
              </Button>
              <Button component={RouterLink} to="/student/login" variant="contained">
                Back to student login
              </Button>
              <Button component={RouterLink} to="/aalogin" variant="outlined">
                Admin login
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </PublicSiteLayout>
  );
}
